var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10C20.5 15.5229 16.0228 20 10.5 20C4.97715 20 0.5 15.5229 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10Z",
    fill: "#FFBA06"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_13539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7826 8.2964C14.1884 5.92919 11.7877 4.49191 9.42051 5.08613C7.57059 5.55052 6.22734 7.14938 6.08894 9.05165C4.77542 9.26826 3.88619 10.5087 4.10281 11.8222C4.29537 12.9899 5.3072 13.8451 6.49068 13.8404H8.49939V13.0369H6.49068C5.60319 13.0369 4.88372 12.3175 4.88372 11.43C4.88372 10.5425 5.60319 9.82299 6.49068 9.82299C6.71257 9.82299 6.89243 9.64314 6.89243 9.42125C6.89042 7.42437 8.5076 5.80394 10.5045 5.80196C12.2331 5.80023 13.7211 7.02228 14.0555 8.7182C14.0885 8.88754 14.2259 9.0169 14.397 9.0396C15.4953 9.196 16.2588 10.2131 16.1024 11.3114C15.962 12.2976 15.1199 13.032 14.1238 13.0369H12.5168V13.8404H14.1238C15.6769 13.8357 16.9322 12.5728 16.9274 11.0197C16.9235 9.72685 16.0386 8.6032 14.7826 8.2964Z",
    fill: "#FEF5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2227 8.83068L8.61572 10.4377L9.18218 11.0041L10.1062 10.0841V13.9368H10.9097V10.0841L11.8297 11.0041L12.3961 10.4377L10.7891 8.83068C10.6324 8.67491 10.3794 8.67491 10.2227 8.83068Z",
    fill: "#FEF5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_13539"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.07031,
    y: 3.57031,
    width: 12.8571,
    height: 12.8571,
    rx: 5.88235,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.d941e23c33ccab92883f865b12554f9c.svg";
export { ForwardRef as ReactComponent };